module.exports = __webpack_public_path__ + "assets/img/slow.4dfbd8c8.svg";